import Layout from '@/layout';

export default [
    // 企业信息
    {
        path: '/entInformation',
        redirect: '/entInformation/index',
        component: Layout,
        meta: {
            title: '企业信息',
            icon: 'menu_qy',
            modules: [5000]
        },
        children: [
            {
                path: 'index',
                name: 'EntInformation',
                component: () => import(/* webpackChunkName: "admin-entInformation" */ '@/views/stageManagement/entInformation/index'),
                meta: {
                    breadcrumb: false,
                    title: '企业信息',
                    modules: [5000]
                }
            },
            {
                path: 'authIfo',
                name: 'AuthIfo',
                hidden: true,
                component: () => import(/* webpackChunkName: "admin-entInformation" */ '@/views/stageManagement/entInformation/apply'),
                meta: {
                    title: '企业信息认证',
                    activeMenu: '/entInformation/index',
                    modules: [5000]
                }
            }
        ]
    },
    {
        path: '/approval',
        component: Layout,
        meta: {
            icon: 'menu_xs',
            modules: [4000]
        },
        children: [
            {
                path: 'index',
                name: 'ApprovalIndex',
                component: () => import(/* webpackChunkName: "admin-approval" */ '@/views/stageManagement/approval/index'),
                meta: {
                    title: '审批管理',
                    keepAlive: true,
                    modules: [4000]
                }
            },
            {
                path: 'detail/:id',
                name: 'ApprovalDetail',
                component: () => import(/* webpackChunkName: "admin-approval" */ '@/views/stageManagement/approval/detail'),
                hidden: true,
                meta: {
                    title: '审批流程详情',
                    activeMenu: '/approval/index',
                    modules: [4000]
                }
            }
        ]
    },
    // 系统日志
    {
        path: '/systemLog',
        component: Layout,
        meta: {
            icon: 'menu_log',
            modules: [7000]
        },
        children: [
            {
                path: 'index',
                name: 'systemLog',
                component: () => import(/* webpackChunkName: "admin-systemLog" */ '@/views/record/index'),
                meta: {
                    title: '系统日志',
                    modules: [7000]
                }
            }
        ]
    }
];
